import { StackClientApp } from '@stackframe/js';

let stackApp = null;

export function getStackApp() {
  if (!stackApp) {
    const projectId = process.env.REACT_APP_STACK_PROJECT_ID;
    const publishableClientKey = process.env.REACT_APP_STACK_PUBLISHABLE_KEY || undefined;
    console.log('[SurfSwell] Initializing StackClientApp with projectId:', projectId, 'hasKey:', !!publishableClientKey);
    stackApp = new StackClientApp({
      projectId,
      publishableClientKey,
      tokenStore: 'cookie',
      urls: {
        oauthCallback: window.location.origin + '/oauth-callback',
      },
    });
  }
  return stackApp;
}
